import axios from "axios";
import { useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
// import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import "./WorkerCategories.css";
import Swal from "sweetalert2";
import { Button, Col, Row, Form } from "react-bootstrap";
import { Formik } from 'formik';
import * as yup from 'yup';
import Modal from 'react-bootstrap/Modal';
import { ICategory, ISubCategory } from "src/helper/interfaces";
import Cookies from "js-cookie";
import Paginator from "src/components/layout/Paginator";
import { formatCategory } from "src/utils/normalFuntions";
import Select from "react-select";
// import makeAnimated from 'react-select/animated';
import { getAllCategories } from "./Workers";
import placeholderImg from "../../../assets/img/landscape-placeholder-svgrepo-com.svg";
import LoadingGif from "src/components/layout/Loader";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
interface InitialValuesType {
   name: string;
   image: string | null;
}

export const getAllSubCategories = async (token: string, pageNumber: number, searchValue: string, pageSize: number, type: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/sub-categories`, {
      headers: {
         "x-access-token": token
      },
      params: {
         page: pageNumber,
         search_value: searchValue,
         pageSize: pageSize,
         type
      }
   })

};
const types = ["Sub Category", "Specification"]


const SubCategoryPage = () => {
   const Token = Cookies.get("token");

   const [editMode, setEditMode] = useState(false);
   const [type, setType] = useState("")
   const [modalShow, setModalShow] = useState(false);
   const [searchVal, setSearchVal] = useState("");
   const [categories, setCategories] = useState<ICategory[]>([])
   const [selectedCategory, setSelectedCategory] = useState<ICategory | null>(null);
   const [subCategories, setSubCategories] = useState<ISubCategory[]>([])
   const [pageNo, setPageNo] = useState(1);
   const [pageSize, setPageSize] = useState(20);
   const [totalPages, setTotalPages] = useState(0);
   const dispatch = useAppDispatch();
   const loading = useAppSelector(state => state?.loading?.value);
   const initialValues: InitialValuesType = {
      name: "",
      image: null,
   };

   const [inputs, setInputs] = useState(initialValues);
   const validationSchema = yup.object().shape({
      name: yup.string()
         .required('Please Fill this field (Name)')
         .test('no-numbers', 'Name should not contain numbers', function (value) {
            return /^[A-Za-z\s*&$-/]+$/.test(value);
         })
      ,
      image: yup.mixed().required('Please upload a file'),
   });


   const onCreate = () => {
      setEditMode(false);
      setModalShow(true);
      setInputs({
         name: "",
         image: null
      })
   }

   const onHide = () => {
      setModalShow(false);
      setEditMode(false);
      // setInputs(initialValues);
   }

   // const onUpdate = (id: string) => {
   //    const subCategoryToEdit = subCategories.find((category) => category._id === id);
   //    setSelectedCategory(subCategoryToEdit);
   //    // console.log(id);
   //    // console.log(subCategoryToEdit);
   //    // console.log(inputs)
   //    // Populate the form fields with the existing data
   //    setInputs({
   //       ...inputs,
   //       name: subCategoryToEdit?.sub_category_name || "",
   //       image: subCategoryToEdit?.sub_category_icon ? subCategoryToEdit?.sub_category_icon : null
   //    });
   //    setEditMode(true);
   //    setModalShow(true);
   // };

   // const handleDeleteConfirmed = (id: string) => {
   //    // console.log(id);
   //    if (Token === undefined) {
   //       console.error("Token is undefined");
   //       return;
   //    }
   //    // Dispatch the delete action here
   //    Swal.fire({
   //       title: 'Are you sure?',
   //       text: "You won't be able to revert this!",
   //       icon: 'warning',
   //       showCancelButton: true,
   //       confirmButtonColor: '#3085d6',
   //       cancelButtonColor: '#d33',
   //       confirmButtonText: 'Yes, delete it!'
   //    }).then(async (response) => {
   //       if (response.isConfirmed) {
   //          // console.log("lamao")
   //          await axios({
   //             url: `${AppConfig.DEV_SERVER}/admin/delete-category/${id}`,
   //             method: "DELETE",
   //             headers: {
   //                'content-type': 'multipart/form-data',
   //                "x-access-token": Token,
   //             }
   //          }).then((res) => {
   //             // console.log(res)
   //             Swal.fire(
   //                'Deleted!',
   //                `${res?.data?.msg}`,
   //                'success'
   //             );
   //             //    getAllSubCategories(Token).then((res) => {
   //             //       console.log(res?.data)
   //             //       if (res?.data?.status_code === 200) {
   //             //          setCategories(res?.data?.data)
   //             //       }
   //             //    })
   //             //       .catch((err: any) => {
   //             //          console.log(err)
   //             //       })
   //             // }).catch((err) => {
   //             //    console.log(err)
   //          })
   //          setModalShow(false);
   //       }
   //    }
   //    )
   // };

   useEffect(() => {
      dispatch(startLoading());
      if (Token) {
         getAllCategories(Token).then((res) => {
            // console.log(res?.data)
            if (res?.data?.status_code === 200) {
               setCategories(res?.data?.data)
            } else {
               Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: `${res?.data?.msg}`,
               });
            }
         })
            .catch((err: any) => {
               console.log(err)
            }).finally(() => dispatch(stopLoading()))
      }

   }, [Token]);

   useEffect(() => {
      getAllSubCategories(Token as string, pageNo, searchVal, pageSize, "all").then((res) => {
      // console.log(res)
         if (res?.data?.status_code === 200) {
            setSubCategories(res?.data?.data?.data);
            setTotalPages(res?.data?.data?.totalPages)
         }
      })
   }, [Token, pageNo, searchVal])

   const handleCatDropdown = (event: React.ChangeEvent<HTMLSelectElement>) => {
      const value = event.target.value;
      console.log(value);
      const convert = value?.toLocaleLowerCase().split(" ")?.join("_")
      console.log("convert: ", convert);
      setType(convert);
   };
   const handleFormSubmit = async (formInput: any, resetForm: () => void) => {
      const formData = new FormData();

      // console.log(formInput);
      if (Object.values(selectedCategory?._id as string)) {
         formData.append('category_id', selectedCategory?._id as string);
      }
      formData.append('sub_category_name', formInput?.name);
      if (formInput.image != "" && formInput.image != undefined) {
         formData.append('sub_category_icon', formInput.image);
      }

      formData.append('type', type);

      // console.log(formInput);
      if (!Token) return;

      if (!editMode) {
         // Add new food item
         // console.log(formData)
         await axios({
            url: `${AppConfig.DEV_SERVER}/subcategories`,
            method: "POST",
            data: formData,
            headers: {
               'content-type': 'multipart/form-data',
               "x-access-token": Token,
            }
         }).then(async () => {

            setModalShow(false);
            Swal.fire({
               position: "center",
               icon: "success",
               title: `Added new Sub Category, '${formInput.name}'.`,
               showConfirmButton: false,
               timer: 1500
            }).then(() => {


               getAllSubCategories(Token as string, pageNo, searchVal, pageSize, "all").then((res) => {
                  // console.log(res)
                  if (res?.data?.status_code === 200) {
                     setSubCategories(res?.data?.data?.data);
                     setTotalPages(res?.data?.data?.totalPages)
                  }
               })
               .catch((err: any) => {
                  console.log(err)
               });
            })

            resetForm();


         })


      }
      else {
         if (selectedCategory != null) {
            if (selectedCategory?._id) {
               formData.append("category_id", selectedCategory?._id)
               // console.log(selectedCategory);
               await axios({
                  url: `${AppConfig.DEV_SERVER}/category`,
                  method: "PUT",
                  headers: {
                     'content-type': 'multipart/form-data',
                     "x-access-token": Token,
                  },
                  data: formData,
               }).then(async () => {
                  // getAllSubCategories(Token).then((res) => {
                  //    console.log(res?.data)
                  //    if (res?.data?.status_code === 200) {
                  //       setCategories(res?.data?.data)
                  //    }
                  // })
                  //    .catch((err: any) => {
                  //       console.log(err)
                  //    });
                  setModalShow(false);
                  Swal.fire({
                     position: "center",
                     icon: "success",
                     title: `Updated category, ${formInput.name}.`,
                     showConfirmButton: false,
                     timer: 1500
                  });
                  resetForm();
               })

            }
         } else {
            console.error("Selected food item or its ID is undefined.");
         }
      }
   }
   const clearSearchValue = () => {
      setSearchVal("");  // Clear the search input
   };
   return (
      <MainLayout searchValue={searchVal} onChange={(e) => setSearchVal(e.target.value)} clearValChange={clearSearchValue}>
         {
            modalShow &&
            <Formik
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {
               handleFormSubmit(values, resetForm)
            }}
            enableReinitialize={true}
            validateOnChange={false}
            validateOnBlur={false}
            initialValues={inputs}
         >
            {({ handleSubmit, handleChange, setFieldValue, values, touched, errors }) => (
               <Modal show={modalShow} onHide={() => onHide()} size="lg" className="rounded-9 category-modal">
                  <Form noValidate onSubmit={handleSubmit}>
                     <Modal.Header closeButton>
                        <Modal.Title as="h5">{editMode ? 'Update Sub Category' : 'Add Sub Category'}</Modal.Title>
                     </Modal.Header>
                     <Modal.Body>
                        <Row className="fieldset-row" >
                           <Col md={12} className="mb-2">
                              <Form.Label htmlFor="provider">Category Name</Form.Label>
                              <Select
                                 className="slect-div"
                                 closeMenuOnSelect={true} // Optional, since it's single-select
                                 name="provider"
                                 isMulti={false} // Single selection
                                 onChange={(selectedOption) => {
                                    // console.log("label: ", selectedOption?.label, "value: ", selectedOption?.value)
                                    setSelectedCategory(selectedOption?.value || null);
                                 }}
                                 value={
                                    selectedCategory
                                       ? { label: selectedCategory.category_name, value: selectedCategory }
                                       : null
                                 }
                                 options={categories?.map((data) => ({ label: data?.category_name, value: data, }))}
                              />

                           </Col>

                           <Col md={12} className="mb-2">
                              <Form.Label htmlFor="provider">Icon</Form.Label>
                              <Form.Control name="image" type="file" onChange={(event: any) => {
                                 const file = event.currentTarget.files[0];
                                 // console.log(file);
                                 setFieldValue("image", file);
                              }} isValid={touched.image && !errors.image} isInvalid={!!errors.image} />
                                    {/* <Form.Control.Feedback type="invalid">
                                 {errors.image}
                              </Form.Control.Feedback> */}
                           </Col>

                           <Col md={12} className="mb-2">
                              <Form.Label htmlFor="name">Sub Category Name</Form.Label>
                              <Form.Control id="name" type='text' onChange={handleChange} isValid={touched.name && !errors.name} value={values.name} isInvalid={!!errors.name} />
                              <Form.Control.Feedback type="invalid">
                                 {errors.name}
                              </Form.Control.Feedback>
                           </Col>
                           <Col md={12} className="mb-2">
                              <Form.Label htmlFor="name">Type</Form.Label>
                              <select
                                 name="worker_type"
                                 value={type.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")} // Reverse transformation for display
                                 onChange={handleCatDropdown}
                                 required
                                 className="form-control"
                              >
                                 {types.map((value, index) => (
                                    <option key={index} value={value}>
                                       {value}
                                    </option>
                                 ))}
                              </select>

                           </Col>

                        </Row>
                     </Modal.Body>
                     <Modal.Footer>
                        <Button variant="app-warning" type="submit" className="ps-4 pe-4 add-cat-btn">
                           {editMode ? 'Update Sub Category' : 'Add Sub Category'}
                        </Button>
                     </Modal.Footer>
                  </Form>
               </Modal>
            )
            }
         </Formik >
         }

         <div className="main-div">
            <div className="card category-main me-2 p-3 p-md-4">
               {
                  loading ? <LoadingGif /> : ""
               }
               <div className="d-flex justify-content-end">


                  <span className="add-cat sub-catu mb-2" onClick={onCreate}>
                     <button className="add-cat-btn ">Add Sub Category</button>
                  </span>

               </div>
               <div className="table-extra-responsive">
                  <table className="table table-striped card-body">
                     <thead>
                        <tr className="category-tr">
                           <th scope="col-md-3" className="text-start ps-4">Sr.No.</th>
                           <th scope="col-md-3" className="text-start ps-4">Sub Category Id</th>
                           <th scope="col-md-3" className="text-start ps-4">Sub Category Name</th>
                           <th scope="col-md-3" className="text-start ps-4">Category name</th>
                           <th scope="col-md-3" className="text-start ps-4">Type</th>
                           <th scope="col-md-1" className="text-start ps-4">Icon</th>
                           {/* <th scope="col-md-2" className="col-lg-2 cat_btns">Action</th> */}
                        </tr>
                     </thead>
                     <tbody>
                        {
                           subCategories && subCategories?.map((data, i) => {

                              const rowNumber = (pageNo - 1) * 20 + (i + 1);
                              // console.log(data?.sub_category_icon)
                              return (

                              <tr key={data?._id}>
                                    <td className="text-start ps-4 pt-3">{rowNumber}</td>
                                 <td className="text-start ps-4 pt-3">{data?._id}</td>
                                 <td className="text-start ps-4 pt-3">{data?.sub_category_name}</td>
                                    <td scope="row" className="text-start ps-4 pt-3">{data?.category_name} </td>
                                    <td scope="row" className="text-start ps-4 pt-3">{formatCategory(data?.type)} </td>
                                 <td className="icon-td text-start ps-4">
                                       {
                                          !data?.sub_category_icon || data?.sub_category_icon.length === 0 ?
                                             <img src={placeholderImg} alt="categories" />
                                             : <img src={data?.sub_category_icon} alt="categories" />
                                       }


                                 </td>
                                 {/* <td className="col-lg-2 d-flex gap-3 cat_btns">
                                 <button className="btn btn-sm edit_btn" onClick={() => onUpdate(data._id)}>
                                    <img src={editIcon} />
                                 </button>
                                 <button className="btn btn-sm delete_btn " onClick={() => handleDeleteConfirmed(data._id)}>
                                    <img src={deleteIcon} />
                                 </button>
                              </td> */}
                              </tr>
                              )
                           })
                        }


                     </tbody>
                  </table>
               </div>


               <Paginator
                  totalPages={totalPages}
                  pageNo={pageNo}
                  onPageChange={(e, no) => setPageNo(no)}
                  alignment="right"
               />
            </div>
         </div>

      </MainLayout>
   )
}

export default SubCategoryPage;